import { createTypedUseTranslate } from '~commons/create-typed-use-translate';
import { CollectionSettingTranslationsKey, CollectionWidgetTranslationKey } from '../locale-types';

export const useSettingsTranslate = createTypedUseTranslate<CollectionSettingTranslationsKey>();

export const useTranslate = createTypedUseTranslate<CollectionWidgetTranslationKey>();
